export default "__VITE_ASSET__777ff5f6__"